import React from "react";
import ReactPaginate from "react-paginate";

import "./index.scss";
import {useLocation} from "react-router-dom";
import {setCurrentPage, setCurrentPage2} from "../../Store/Slice/jobsSlice";
import {useDispatch} from "react-redux";

export const Paginate = ({ currentPage, setCurrentPage, pageCount }) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const handlePageClick = (item) => {
    setCurrentPage(item?.selected + 1);
    if(location?.pathname === '/jobs') {
      dispatch(setCurrentPage2(item?.selected + 1));
    }
  };

  return (
    <>
    <div className="paginate">
        <ReactPaginate
          breakLabel="..."
          nextLabel={<img src="/assets/icons/paginate-arrow.svg" />}
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel={<img src="/assets/icons/paginate-arrow.svg" />}
          containerClassName="paginate__container"
          renderOnZeroPageCount={null}
        />
      </div>
    </>
  );
};
